<!--================================
=            SIMPLELINE            =
=================================-->
<template>  <v-container >
    <v-row no-gutters>
      <base-header>
        <div slot="page-header">Simpleline</div>
      </base-header>
    </v-row>

    <v-row no-gutters>
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-4">
         <div slot="card-header">Simpleline Icons</div>
							<div slot="card-body">
								<div class="row icons-list">
									<div v-for="icon in icons" :key="icon" class="col-sm-6 col-md-4 col-lg-3">
										<i :class="icon.name"></i> {{icon.name}}
									</div>
								</div>
							</div>
        </base-card>
      </v-col>
     
    </v-row>

  </v-container>
	
</template>
<script>  import BaseCard from "../../layout/Base/BaseCard.vue";
import BaseHeader from "../../layout/Base/BaseHeader.vue";
  export default {
    components: {
      BaseCard,BaseHeader
    },
		data() {
			return {
				icons: [{
						"name": "icon icon-user"
					},
					{
						"name": "icon icon-people"
					},
					{
						"name": "icon icon-user-female"
					},
					{
						"name": "icon icon-user-follow"
					},

					{
						"name": "icon icon-user-following"
					},


					{
						"name": "icon icon-user-unfollow"
					},


					{
						"name": "icon icon-login"
					},
					{
						"name": "icon icon-logout"
					},
					{
						"name": "icon icon-emotsmile"
					},
					{
						"name": "icon icon-phone"
					},
					{
						"name": "icon icon-call-end"
					},
					{
						"name": "icon icon-call-in"
					},
					{
						"name": "icon icon-call-out"
					},
					{
						"name": "icon icon-map"
					},
					{
						"name": "icon icon-location-pin"
					},
					{
						"name": "icon icon-direction"
					},
					{
						"name": "icon icon-directions"
					},
					{
						"name": "icon icon-compass"
					},
					{
						"name": "icon icon-layers"
					},
					{
						"name": "icon icon-menu"
					},
					{
						"name": "icon icon-list"
					},

					{
						"name": "icon icon-options-vertical"
					},

					{
						"name": "icon icon-options"
					},
					{
						"name": "icon icon-arrow-down"
					},
					{
						"name": "icon icon-arrow-left"
					},
					{
						"name": "icon icon-arrow-right"
					},
					{
						"name": "icon icon-arrow-up"
					},

					{
						"name": "icon icon-arrow-up-circle"
					},



					{
						"name": "icon icon-arrow-left-circle"
					},



					{
						"name": "icon icon-arrow-right-circle"
					},



					{
						"name": "icon icon-arrow-down-circle"
					},


					{
						"name": "icon icon-check"
					},
					{
						"name": "icon icon-clock"
					},
					{
						"name": "icon icon-plus"
					},
					{
						"name": "icon icon-minus"
					},
					{
						"name": "icon icon-close"
					},
					{
						"name": "icon icon-event"
					},
					{
						"name": "icon icon-exclamation"
					},
					{
						"name": "icon icon-organization"
					},
					{
						"name": "icon icon-trophy"
					},

					{
						"name": "icon icon-screen-smartphone"
					},



					{
						"name": "icon icon-screen-desktop"
					},


					{
						"name": "icon icon-plane"
					},
					{
						"name": "icon icon-notebook"
					},
					{
						"name": "icon icon-mustache"
					},
					{
						"name": "icon icon-mouse"
					},
					{
						"name": "icon icon-magnet"
					},
					{
						"name": "icon icon-energy"
					},
					{
						"name": "icon icon-disc"
					},
					{
						"name": "icon icon-cursor"
					},
					{
						"name": "icon icon-cursor-move"
					},
					{
						"name": "icon icon-crop"
					},
					{
						"name": "icon icon-chemistry"
					},
					{
						"name": "icon icon-speedometer"
					},
					{
						"name": "icon icon-shield"
					},

					{
						"name": "icon icon-screen-tablet"
					},


					{
						"name": "icon icon-magic-wand"
					},
					{
						"name": "icon icon-hourglass"
					},
					{
						"name": "icon icon-graduation"
					},
					{
						"name": "icon icon-ghost"
					},

					{
						"name": "icon icon-game-controller"
					},


					{
						"name": "icon icon-fire"
					},
					{
						"name": "icon icon-eyeglass"
					},

					{
						"name": "icon icon-envelope-open"
					},



					{
						"name": "icon icon-envelope-letter"
					},


					{
						"name": "icon icon-bell"
					},
					{
						"name": "icon icon-badge"
					},
					{
						"name": "icon icon-anchor"
					},
					{
						"name": "icon icon-wallet"
					},
					{
						"name": "icon icon-vector"
					},
					{
						"name": "icon icon-speech"
					},
					{
						"name": "icon icon-puzzle"
					},
					{
						"name": "icon icon-printer"
					},
					{
						"name": "icon icon-present"
					},
					{
						"name": "icon icon-playlist"
					},
					{
						"name": "icon icon-pin"
					},
					{
						"name": "icon icon-picture"
					},
					{
						"name": "icon icon-handbag"
					},
					{
						"name": "icon icon-globe-alt"
					},
					{
						"name": "icon icon-globe"
					},
					{
						"name": "icon icon-folder-alt"
					},
					{
						"name": "icon icon-folder"
					},
					{
						"name": "icon icon-film"
					},
					{
						"name": "icon icon-feed"
					},
					{
						"name": "icon icon-drop"
					},
					{
						"name": "icon icon-drawer"
					},
					{
						"name": "icon icon-docs"
					},
					{
						"name": "icon icon-doc"
					},
					{
						"name": "icon icon-diamond"
					},
					{
						"name": "icon icon-cup"
					},
					{
						"name": "icon icon-calculator"
					},
					{
						"name": "icon icon-bubbles"
					},
					{
						"name": "icon icon-briefcase"
					},
					{
						"name": "icon icon-book-open"
					},

					{
						"name": "icon icon-basket-loaded"
					},


					{
						"name": "icon icon-basket"
					},
					{
						"name": "icon icon-bag"
					},
					{
						"name": "icon icon-action-undo"
					},
					{
						"name": "icon icon-action-redo"
					},
					{
						"name": "icon icon-wrench"
					},
					{
						"name": "icon icon-umbrella"
					},
					{
						"name": "icon icon-trash"
					},
					{
						"name": "icon icon-tag"
					},
					{
						"name": "icon icon-support"
					},
					{
						"name": "icon icon-frame"
					},

					{
						"name": "icon icon icon-size-fullscreen"
					},


					{
						"name": "icon icon-size-actual"
					},
					{
						"name": "icon icon-shuffle"
					},
					{
						"name": "icon icon-share-alt"
					},
					{
						"name": "icon icon-share"
					},
					{
						"name": "icon icon-rocket"
					},
					{
						"name": "icon icon-question"
					},
					{
						"name": "icon icon-pie-chart"
					},
					{
						"name": "icon icon-pencil"
					},
					{
						"name": "icon icon-note"
					},
					{
						"name": "icon icon-loop"
					},
					{
						"name": "icon icon-home"
					},
					{
						"name": "icon icon-grid"
					},
					{
						"name": "icon icon-graph"
					},
					{
						"name": "icon icon-microphone"
					},

					{
						"name": "icon icon-music-tone-alt"
					},


					{
						"name": "icon icon-music-tone"
					},

					{
						"name": "icon icon-earphones-alt"
					},


					{
						"name": "icon icon-earphones"
					},
					{
						"name": "icon icon-equalizer"
					},
					{
						"name": "icon icon-like"
					},
					{
						"name": "icon icon-dislike"
					},

					{
						"name": "icon icon-control-start"
					},



					{
						"name": "icon icon-control-rewind"
					},


					{
						"name": "icon icon-control-play"
					},

					{
						"name": "icon icon-control-pause"
					},



					{
						"name": "icon icon-control-forward"
					},


					{
						"name": "icon icon-control-end"
					},
					{
						"name": "icon icon-volume-1"
					},
					{
						"name": "icon icon-volume-2"
					},
					{
						"name": "icon icon-volume-off"
					},
					{
						"name": "icon icon-calendar"
					},
					{
						"name": "icon icon-bulb"
					},
					{
						"name": "icon icon-chart"
					},
					{
						"name": "icon icon-ban"
					},
					{
						"name": "icon icon-bubble"
					},
					{
						"name": "icon icon-camrecorder"
					},
					{
						"name": "icon icon-camera"
					},

					{
						"name": "icon icon-cloud-download"
					},


					{
						"name": "icon icon-cloud-upload"
					},
					{
						"name": "icon icon-envelope"
					},
					{
						"name": "icon icon-eye"
					},
					{
						"name": "icon icon-flag"
					},
					{
						"name": "icon icon-heart"
					},
					{
						"name": "icon icon-info"
					},
					{
						"name": "icon icon-key"
					},
					{
						"name": "icon icon-link"
					},
					{
						"name": "icon icon-lock"
					},
					{
						"name": "icon icon-lock-open"
					},
					{
						"name": "icon icon-magnifier"
					},

					{
						"name": "icon icon-magnifier-add"
					},



					{
						"name": "icon icon-magnifier-remove"
					},


					{
						"name": "icon icon-paper-clip"
					},
					{
						"name": "icon icon-paper-plane"
					},
					{
						"name": "icon icon-power"
					},
					{
						"name": "icon icon-refresh"
					},
					{
						"name": "icon icon-reload"
					},
					{
						"name": "icon icon-settings"
					},
					{
						"name": "icon icon-star"
					},

					{
						"name": "icon icon-symbol-female"
					},


					{
						"name": "icon icon-symbol-male"
					},
					{
						"name": "icon icon-target"
					},
					{
						"name": "icon icon-credit-card"
					},
					{
						"name": "icon icon-paypal"
					},

					{
						"name": "icon icon-social-tumblr"
					},



					{
						"name": "icon icon-social-twitter"
					},



					{
						"name": "icon icon-social-facebook"
					},



					{
						"name": "icon icon-social-instagram"
					},



					{
						"name": "icon icon-social-linkedin"
					},



					{
						"name": "icon icon-social-pinterest"
					},



					{
						"name": "icon icon-social-github"
					},



					{
						"name": "icon icon-social-google"
					},



					{
						"name": "icon icon-social-reddit"
					},


					{
						"name": "icon icon-social-skype"
					},

					{
						"name": "icon icon-social-dribbble"
					},



					{
						"name": "icon icon-social-behance"
					},



					{
						"name": "icon icon-social-foursqare"
					},



					{
						"name": "icon icon-social-soundcloud"
					},



					{
						"name": "icon icon-social-spotify"
					},



					{
						"name": "icon icon-social-stumbleupon"
					},



					{
						"name": "icon icon-social-youtube"
					},



					{
						"name": "icon icon-social-dropbox"
					},



					{
						"name": "icon icon-social-vkontakte"
					},


					{
						"name": "icon icon-social-steam"
					},
				]
			}
		}
	}
</script>
<style scoped>
	/*
 * Icons Styles
 * ----------------------
 */

	/*--Ionicons*--*/

	.icons-list {
		color: #706c73
	}

	.icons-list div {
		cursor: pointer;
		line-height: 45px;
		white-space: nowrap;
		text-overflow: ellipsis;
		display: block;
		overflow: hidden;
		text-align: center
	}

	.icons-list i {
		font-size: 22px;
		line-height: 30px;
		display: block
	}

	.button-examples {
		margin-left: -5px;
		margin-bottom: -10px
	}

	.button-examples .btn {
		margin-bottom: 10px;
		margin-left: 5px
	}


	/*-- end ionicons--- */
</style>

<!--====  End of SIMPLELINE  ====-->